import React from "react";
import { Input as NovusInput } from "@arcadis-intelligence/novus-design-system";
import { InputProps } from "./helpers";
import { TextArea } from "../Textarea";
import { inputStyles } from "../variants";

export const Input: React.FC<InputProps> = ({
    autoFocus,
    className,
    type,
    onChange,
    label,
    placeholder,
    asterisk = false,
    isMultiline,
    value,
    disabled,
    maxLength,
    defaultValue,
    name,
    onInputChange,
    onKeyDown,
    isAdditionalInfo,
    hintText,
    error,
    minLength,
    iconRight,
    isMargin = false,
    numberValue = 0,
    ...props
}) => {
    return (
        <>
            {isMultiline ? (
                <TextArea
                    aria-label={value}
                    className={className}
                    defaultValue={defaultValue}
                    disabled={disabled}
                    maxLength={maxLength}
                    minLength={minLength}
                    name={name}
                    placeholder=""
                    rows={1}
                    value={value}
                    onChange={(event: React.ChangeEvent<HTMLTextAreaElement>): void => {
                        if (onInputChange) {
                            onInputChange(event.target.value);
                        }
                    }}
                    onKeyDown={onKeyDown}
                    label={label}
                    asterisk={asterisk}
                    error={error}
                    hintText={hintText}
                    isMargin={isMargin}
                />
            ) : (
                <NovusInput
                    autoFocus={autoFocus}
                    className={className}
                    onChange={(event: React.ChangeEvent<HTMLInputElement> | string): void => {
                        if (onInputChange) {
                            if (type === "number") {
                                onInputChange(event as string);
                            } else {
                                onInputChange(
                                    (event as React.ChangeEvent<HTMLInputElement>).target.value
                                );
                            }
                        } else if (onChange) {
                            onChange(event as React.ChangeEvent<HTMLInputElement>);
                        }
                    }}
                    type={type}
                    label={label}
                    placeholder={placeholder ?? ""}
                    asterisk={asterisk}
                    isDisabled={disabled}
                    value={type === "number" ? numberValue : value}
                    defaultValue={defaultValue}
                    isAdditionalInfo={isAdditionalInfo}
                    onKeyDown={onKeyDown}
                    error={error}
                    hintText={hintText}
                    iconRight={iconRight}
                    isMargin={isMargin}
                    {...inputStyles}
                    {...props}
                />
            )}
        </>
    );
};
